import React from "react";
import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => (
  <section data-testid="marquee" className="py-10 md:py-16 border-y-2 border-[#0B0E14] overflow-hidden bg-[#0B0E14]">
    <Marquee speed={40} gradient={false}>
      {["FUNKY APPAREL", "DROP 001", "NO RESTOCK", "SHIPPED ACROSS THE USA"].map((t) => (
        <span key={t} className="font-bodoni text-6xl md:text-8xl mx-8 uppercase tracking-tight" style={{ color: "transparent", WebkitTextStroke: "1.5px #EDEEF1" }}>
          {t} <span className="mx-8 volt" style={{ WebkitTextStroke: 0 }}>✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
